import { Component, Input } from '@angular/core';
import { IGAFormHelper } from './forms.service';

@Component({
  selector: 'forms-help',
  template: `
    <div *ngIf="help" class="row" [id]="helpId?.toLowerCase()">
      <div class="col-md-12 col-space-bottom" [class.help-toggle]="showToggle">
        <span class="fa fa-info-circle info-icon" *ngIf="showToggle" (click)="toggleHelp()"></span>
        <ng-container *ngIf="help.textVisible">
          <p class="form-help-text" *ngIf="help.text" [innerHTML]="help.text"></p>
          <a class="form-help-link" *ngIf="help.url" [href]="help.url" target="_blank" [innerHTML]="help.label"></a>
        </ng-container>
      </div>
    </div>
  `
})
export class FormsHelpComponent {
  @Input() public help: IGAFormHelper;
  @Input() public helpId: string;
  @Input() public showToggle: boolean;

  constructor() {
    /**/
  }

  public toggleHelp(): void {
    this.help.textVisible = !this.help.textVisible;
  }
}